module.exports = __webpack_public_path__ + "df682eed23533401877cd66fc1e625db.svg";